import { useContext } from 'react';
import { AppContext } from '../context/AppContext';

/**
 * Хук для роботи з AppContext
 * Надає доступ до глобального стану додатку
 */
export const useApp = () => {
  const context = useContext(AppContext);
  
  if (!context) {
    throw new Error('useApp повинен використовуватися всередині AppProvider');
  }
  
  return context;
};

export default useApp;